import { combineReducers } from "redux";
import gameReducer from "./Game/gameReducer";

const rootReducer = combineReducers({
    game : gameReducer
})

export default rootReducer